import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import type { EnergyFlow } from "../lib/types";

interface Props {
  flow: EnergyFlow;
}

export function MonthlyFlowChart({ flow }: Props) {
  const data = flow.months.map((m) => ({
    maand: m.name,
    Productie: Math.round(m.production_kwh),
    Verbruik: Math.round(m.consumption_kwh),
    Import: Math.round(m.import_kwh),
    Export: Math.round(m.export_kwh),
  }));

  return (
    <div>
      <div className="serif text-base font-medium mb-2">Maandverloop (kWh)</div>
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={data} margin={{ left: 0, right: 10, top: 5, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E5DFD3" />
          <XAxis dataKey="maand" tick={{ fill: "#6B6661", fontSize: 11 }} />
          <YAxis tick={{ fill: "#6B6661", fontSize: 11 }} />
          <Tooltip
            contentStyle={{ background: "#FFFFFF", border: "1px solid #C9C0B0", borderRadius: 8 }}
            formatter={(v: number) => `${v} kWh`}
          />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          <Bar dataKey="Productie" fill="#4A7560" />
          <Bar dataKey="Verbruik" fill="#9A938A" />
          <Bar dataKey="Import" fill="#C66A3D" />
          <Bar dataKey="Export" fill="#2C4A3E" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
